/* DarkFantasy — checkout remains a native Shopify form. */
(() => {
  'use strict';
  const initProduct = root => {
    if (root.dataset.ready) return;
    const select = root.querySelector('[data-variant-select]');
    const data = root.querySelector('[data-variant-data]');
    if (!select || !data) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch { return; }
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-product-form]');
    const buy = root.querySelector('[data-submit-button]');
    const panels = [...root.querySelectorAll('[data-media-panel]')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    const choices = [...root.querySelectorAll('[data-variant-choice]')];
    const status = root.querySelector('[data-product-status]');
    const showMedia = (id, announce = false) => {
      const panel = panels.find(el => el.dataset.mediaPanel === String(id)) || panels[0];
      if (!panel) return;
      panels.forEach(el => {
        el.hidden = el !== panel;
        if (el !== panel) el.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === panel.dataset.mediaPanel)));
      const counter = root.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${panels.indexOf(panel) + 1} / ${panels.length}`;
      if (announce && status) status.textContent = `Visuel ${panels.indexOf(panel) + 1} sur ${panels.length}.`;
    };
    const update = (changeUrl = true) => {
      const variant = variants.find(item => String(item.id) === select.value);
      choices.forEach(el => el.setAttribute('aria-pressed', String(el.dataset.variantChoice === select.value)));
      if (!variant) { buy.disabled = true; buy.textContent = 'Indisponible'; return; }
      root.querySelector('[data-product-price]').textContent = variant.price;
      const compare = root.querySelector('[data-compare-price]');
      compare.textContent = variant.compare || '';
      compare.hidden = !variant.compare;
      buy.disabled = !variant.available;
      buy.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      const availability = root.querySelector('[data-availability]');
      if (availability) availability.textContent = variant.available ? 'Disponible' : 'Actuellement épuisé';
      const payment = root.querySelector('[data-payment-button]');
      if (payment) payment.hidden = !variant.available;
      const quantity = root.querySelector('[name="quantity"]');
      if (quantity && variant.quantity) {
        quantity.min = variant.quantity.min || 1;
        quantity.step = variant.quantity.increment || 1;
        if (variant.quantity.max != null) quantity.max = variant.quantity.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      }
      const caption = root.querySelector('[data-variant-title]');
      if (caption) caption.textContent = variant.title;
      showMedia(variant.media);
      if (changeUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (status) status.textContent = `${variant.title}, ${variant.price}. ${variant.available ? 'Disponible.' : 'Épuisé.'}`;
      }
    };
    select.addEventListener('change', () => update());
    choices.forEach(choice => choice.addEventListener('click', () => {
      select.value = choice.dataset.variantChoice;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    thumbs.forEach(thumb => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget, true)));
    root.querySelector('[data-gallery-thumbs]')?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const current = thumbs.indexOf(document.activeElement);
      if (current < 0) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].focus(); thumbs[next].click();
    });
    form.addEventListener('submit', event => {
      const variant = variants.find(item => String(item.id) === select.value);
      if (!variant?.available || form.dataset.submitting) { event.preventDefault(); return; }
      form.dataset.submitting = 'true';
      buy.setAttribute('aria-busy', 'true'); buy.textContent = 'Ajout en cours…';
    });
    window.addEventListener('pageshow', () => {
      delete form.dataset.submitting; buy.removeAttribute('aria-busy'); update(false);
    });
    root.classList.add('product-enhanced'); update(false);
  };
  const init = (scope = document) => scope.querySelectorAll('[data-product]').forEach(initProduct);
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button) return;
    const input = button.closest('[data-quantity]').querySelector('input');
    if (Number(button.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.mobile-menu[open]').forEach(menu => {
      menu.open = false; menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
